import { render, staticRenderFns } from "./ProductFactor.vue?vue&type=template&id=484fa5a1&"
import script from "./ProductFactor.vue?vue&type=script&lang=js&"
export * from "./ProductFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports